import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivityGroupFieldComponent } from './activity-group-field.component';
import { DxSelectBoxModule, DxTextBoxModule } from 'devextreme-angular';



@NgModule({
	declarations: [ActivityGroupFieldComponent],
	exports: [ActivityGroupFieldComponent],
  imports: [
		CommonModule,
		DxSelectBoxModule,
		DxTextBoxModule
  ]
})
export class ActivityGroupFieldModule { }
